import type { AxiosInstance } from 'axios'
import { PRODUCTS } from '@/constants/products'
import type { OccasionId } from '@/schemas/occasion.schema'
import type { Product, ProductCategory } from '@/schemas/product.schema'

export interface IProductsService {
  listAll(): Promise<Product[]>
  listByCategory(category: ProductCategory): Promise<Product[]>
  findBySlug(slug: string): Promise<Product | null>
  listByOccasion(occasion: OccasionId): Promise<Product[]>
}

export class ProductsService implements IProductsService {
  constructor(readonly httpClient: AxiosInstance) {}

  async listAll(): Promise<Product[]> {
    return PRODUCTS
  }

  async listByCategory(category: ProductCategory): Promise<Product[]> {
    return PRODUCTS.filter((product) => product.category === category)
  }

  async findBySlug(slug: string): Promise<Product | null> {
    return PRODUCTS.find((product) => product.slug === slug) ?? null
  }

  async listByOccasion(occasion: OccasionId): Promise<Product[]> {
    return PRODUCTS.filter((product) => product.occasions.includes(occasion))
  }
}
